import api from '~api'
import moment from 'moment'
import {
  convertPages
} from '~utils/api'
export const url = `/student`

function requestProfileConverter(profile) {
  return {
    account: profile.student_id,
    email: profile.student_email,
    sex: profile.sex,
    alt_email: profile.student_alt_email,
    department_id: profile.student_department,
    grade: profile.student_grade,
    name: profile.student_name,
    tel: profile.student_phone_number,
    lineUID: profile.student_lineUID,
    lineSetting: profile.student_lineSetting,
    lineCategory: profile.student_lineCategory,
    lineNews: profile.student_lineNews
  }
}

export async function postStudentLogin({
  id, password
}) {
  const {
    data
  } = await api.post(`${url}/login`, {
    account: id,
    password
  })

  return ({
    token: data.access_token,
    token_expired_at: moment().add(data.expires_in, 's')._d
  })
}

export async function postStudentSignup(account) {
  const {
    data
  } = await api.post(`${url}/send-email`, {
    account
  })

  return data
}

export async function getStudentDepartments(degree) {
  const {
    data
  } = await api.get(`${url}/department`, {
    params: {
      system: degree
    }
  })

  const departments = data.data.map((dept) => {
    return {
      department_id: dept.id,
      department_degree: dept.system,
      department_name: dept.name,
      department_en_US: dept.en_US,
    }
  })
  return (departments)
}

export async function getInternDepartments() {
  const {
    data
  } = await api.get(`${url}/department_ofs`)

  const department_ofs = data.data.map((dept) => {
    return {
      department_id: dept.id,
      department_name: dept.name,
      department_en_US: dept.en_US,
    }
  });

  return department_ofs;
}

export async function postStudentRegister(profile) {
  const request = Object.assign({}, {
    token: profile.token,
    password: profile.password,
    password_confirmation: profile.password_confirmation,
    ...requestProfileConverter(profile)
  })

  const {
    data
  } = await api.post(`${url}/register`, request)
  return data
}

export async function getStudentLogout() {
  const {
    data
  } = await api.get(`${url}/logout`)
  return data
}

export async function getStudent() {
  const {
    data
  } = await api.get(`${url}`)

  const response = data.data

  const student = {
    student_pk_id: response.id,
    student_id: response.account,
    student_department_name: response.department.name,
    student_department: response.department_id,
    student_grade: response.grade,
    student_name: response.name,
    student_phone_number: response.tel,
    student_academic_degree: response.department.system,
    student_alt_email: response.alt_email,
    student_sex: response.sex,
    student_lineUID: response.lineUID,
    student_lineSetting: response.lineSetting,
    student_lineCategory: response.lineCategory,
    student_lineNews: response.lineNews
  }
  return student
}

export async function getStudentReminder() {
  const {
    data
  } = await api.get(`/getReminder`)

  return data
}

export async function getLineSetting() {
  const {
    data
  } = await api.get(`/lineSetting`)
  return data
}

export async function getLineCategory() {
  const {
    data
  } = await api.get(`/lineCategory`)
  return data

}

export async function putStudent(profile) {
  const request = Object.assign({}, requestProfileConverter(profile))
console.log(request);
  if (profile.password) {
    putStudentPassword(profile)
  }

  const {
    data
  } = await api.put(`${url}`, request)

  return data
}

export async function putStudentPassword(profile) {
  const passwordRequest = {
    password: profile.password,
    password_confirmation: profile.password_confirmation
  }
  const {
    data
  } = await api.put(`${url}/reset-password`, passwordRequest)

  return data
}

export async function getStudentEnterpriseVisitEnrollments(params) {
  const {
    data
  } = await api.get(`${url}/corporate-visit`, { params })

  const enrollments = data.data.map(enrollment => {
    return {
      visit_id: enrollment.id,
      visit_date_time_start: enrollment.event_start_date,
      visit_date_time_end: enrollment.event_end_date,
      visit_company: enrollment.name,
      visit_enrollment_deadline: enrollment.end_date,
      visit_enrollment_status: enrollment.student.status
    }
  })
  const pages = convertPages(data.meta)
  return { enrollments, pages }
}

export async function putStudentEnterpriseVisitEnrollment(enrollmentId) {
  const {
    data
  } = await api.put(`${url}/corporate-visit/${enrollmentId}`)

  return data
}

const typeUrls = ['career-mentor', 'workplace-mentor']
export async function getStudentCareerCounsellingEnrollments(type, params) {
  const typeMentor = ['careerMentor', 'workplaceMentor']
  const {
    data
  } = await api.get(`${url}/${typeUrls[type]}`, { params })

  const enrollments = data.data.map(counselling => {
    return {
      counselling_id: counselling.id,
      counselling_time_start: `${counselling.date} ${counselling.start}`,
      counselling_time_end: `${counselling.date} ${counselling.end}`,
      counselling_resident_start: counselling.resident_start,
      counselling_resident_end: counselling.resident_end,
      counselor_name: counselling[typeMentor[type]].name,
      counselor_work_at: counselling[typeMentor[type]].unit,
      counselling_enrollment_status: counselling.student.status
    }
  })
  const pages = convertPages(data.meta)
  return { enrollments, pages }
}

export async function putStudentCareerCounsellingEnrollment({
  type,
  enrollmentId
}) {
  const {
    data
  } = await api.put(`${url}/${typeUrls[type]}/${enrollmentId}`)

  return data
}
export async function getStudentCareerLectureEnrollments(params) {
  const {
    data
  } = await api.get(`${url}/career-lecture`, { params })

  const enrollments = data.data.map(lecture => {
    return {
      lecture_id: lecture.id,
      lecture_date_time_start: lecture.event_start_date,
      lecture_date_time_end: lecture.event_end_date,
      lecture_enrollment_deadline: lecture.end_date,
      lecture_topic: lecture.subject,
      lecture_enrollment_status: lecture.student.status
    }
  })
  const pages = convertPages(data.meta)
  return { enrollments, pages }
}

export async function putStudentCareerLectureEnrollment(enrollmentId) {
  const {
    data
  } = await api.put(`${url}/career-lecture/${enrollmentId}`)

  return data
}

export async function postStudentForgetPassword(account) {
  const {
    data
  } = await api.post(`${url}/send-forget-email`, {
    account
  })

  return data
}

export async function postStudentResetPassword(params) {
  const {
    data
  } = await api.post(`${url}/forget-password`, params)

  return data
}

export async function postStudentEnrollLecture(enrollment) {
  console.log(enrollment);
  const {
    data
  } = await api.post(`${url}/career-lecture`, {
    career_lecture_id: enrollment.lecture_id,
    birthday: enrollment.student_birthday,
    identity: enrollment.student_id_card_number,
    email: enrollment.student_alternate_email,
    tel: enrollment.student_alternate_phone_number,
    gender: enrollment.sex,
    foods: enrollment.foods,
    student_name : enrollment.student_name,
    student_tel : enrollment.student_tel, 
  })

  return data
}

export async function getStudentCareerLectureEnrollmentsById(id) {
  const {
    data
  } = await api.get(`${url}/career-lecture/${id}`)
  const response = data.data

  const enrollment = {
    lecture_id: response.id,
    lecture_date_time_start: response.event_start_date,
    lecture_date_time_end: response.event_end_date,
    lecture_enrollment_deadline: response.end_date,
    lecture_topic: response.subject,
    lecture_enrollment_status: response.student.status
  }
  return enrollment
}

export async function postStudentEnrollVisit(enrollment) {
  const {
    data
  } = await api.post(`${url}/corporate-visit`, {
    corporate_visit_id: enrollment.visit_id,
    birthday: enrollment.student_birthday,
    identity: enrollment.student_id_card_number,
    email: enrollment.student_alternate_email,
    tel: enrollment.student_alternate_phone_number,
    gender: enrollment.sex,
    foods: enrollment.foods,
    student_name : enrollment.student_name,
    student_tel : enrollment.student_tel, 
  })

  return data
}

async function enrollForCareerCounselor(appointment) {
  const {
    data
  } = await api.post(`${url}/career-mentor`, {
    career_resident_id: appointment.appointment_time_slot.appointment_counselor_id,
    career_item_ids: appointment.appointment_services,
    student_alternate_email: appointment.student_alternate_email,
    student_alternate_phone_number: appointment.student_alternate_phone_number,
    student_gender : appointment.sex,
    student_name : appointment.student_name,
    student_tel : appointment.student_tel, 
  })
  return data
}

async function enrollForIndustryMentor(appointment) {
  const {
    data
  } = await api.post(`${url}/workplace-mentor`, {
    workplace_resident_id: appointment.appointment_time_slot.appointment_counselor_id,
    workplace_item_ids: appointment.appointment_services,
    student_alternate_email: appointment.student_alternate_email,
    student_alternate_phone_number: appointment.student_alternate_phone_number,
    student_gender : appointment.sex,
    student_name : appointment.student_name,
    student_tel : appointment.student_tel, 
  })
  return data
}

export async function postStudentEnrollCareerCounselling({ type, appointment }) {
  if (type === 'career-counselors') {
    return enrollForCareerCounselor(appointment)
  }

  return enrollForIndustryMentor(appointment)
}

export async function getInternSearchOptions() {
  const {
    data
  } = await api.get(`${url}/getInternSearchOptions`)

  const internSearchOptions = data;

  return {
    internSearchOptions,
  }
}

export async function getInternRecordList(params) {
  const {
    data
  } = await api.get(`${url}/getInternRecordList`, { params })

  const internRecordList = data.data.map(record => {
    return {
      year: record.year,
      start_date: record.start_date,
      end_date: record.end_date,
      student_id: record.student_id,
      enterprise_id: record.enterprise_id,
      enterprise_name: record.enterprise_name,
      lecture_name: record.lecture_name,
    };
  });

  return {
    internRecordList,
  };
}

export async function getEnterprisesList(keyword) {
  let params = { search: keyword };
  const {
    data
  } = await api.get(`${url}/getInternCompany`, { params })

  const internEnterpriseList = data.map(enterprise => {
    return {
      enterprise_id: enterprise.id,
      enterprise_name: enterprise.name,
    };
  });

  return {
    internEnterpriseList,
  };
}

export async function sendInternForm({ type, params }) {
  const {
    data
  } = await api.post(`${url}/form/${type}/sendForm`, params)

  return data
}

export async function getInternForm({ type, params }) {
  const {
    data
  } = await api.get(`${url}/form/${type}/getForm`, { params })

  const formData = data.data;

  return {
    formData
  }
}

export async function getFileNameList({ type, params }) {
  const {
    data
  } = await api.get(`${url}/form/${type}/getFileNameList`, { params });

  const fileNameList = data.data;

  return {
    fileNameList,
  }
}

export async function deleteInternFile({ type, form_id }) {
  const {
    data
  } = await api.post(`${url}/form/${type}/deleteFile`, { id: form_id });

  return data
}

export async function uploadInternFormFile({ type, params }) {
  const {
    data
  } = await api.post(`${url}/form/${type}/setFile`, params);

  return data
}

export async function downloadInternFormFile({ type, form_id }) {
  const {
    data,
    headers
  } = await api.post(`${url}/form/${type}/download`, { id: form_id }, { responseType: 'blob' ,  headers: {
    'No-Success-Notification': 'true'
  }});

  // create "a" HTML element with href to file & click
  const link = document.createElement('a');

  // create file link in browser's memory
  link.href = URL.createObjectURL(data);

  // get file name from content-disposition
  var filename = "";
  let disposition = headers['content-disposition'];
  if (disposition && disposition.indexOf('attachment') !== -1) {
    var filenameRegex = /filename\*?=([^']*'')?([^;]*)/;
    var matches = filenameRegex.exec(disposition);
    if (matches != null && matches[2]) {
      filename = decodeURIComponent(matches[2].replace(/['"]/g, ''));
    }
  }

  // setup file name
  filename = filename.replace(/.*\//g, '').replace(/^[^_]*_[^_]*_/,'');
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();

  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);

  return undefined;
}
